import React from 'react';

const AboutUs = () => {
    return (
        <div className='min-h-screen'>
            this is about us page
        </div>
    );
};

export default AboutUs;